<template>
  <base-draggable-modal
      name="send_project_reports"
      max-height="80vh"
      width="70vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="send_project_reports">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate("progress_report") }} {{ moment().format("DD-MM-YYYY") }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-row>
              <v-col cols="3" style="align-content: center;">
                {{ $store.getters.translate("high_level_overview") }}
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                    class="reg-normal text-primary"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    density="default"
                    v-model="overview_template"
                    :items="templates"
                    :return-object="false"
                    item-value="value"
                    item-title="text"
                    hide-details
                    clearable>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('template') }}</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col>
                <v-autocomplete
                    class="reg-normal text-primary"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    density="default"
                    v-model="overview_users"
                    :items="users"
                    :return-object="false"
                    item-value="value"
                    item-title="text"
                    chips
                    closable-chips
                    hide-details
                    multiple>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('user') }}</span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" style="align-content: center;">
                {{ $store.getters.translate("high_level_overview_with_e_i") }}
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                    class="reg-normal text-primary"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    density="default"
                    v-model="overview_with_e_i_template"
                    :items="templates"
                    :return-object="false"
                    item-value="value"
                    item-title="text"
                    hide-details
                    clearable>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('template') }}</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col>
                <v-autocomplete
                    class="reg-normal text-primary"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    density="default"
                    v-model="overview_with_e_i_users"
                    :items="users"
                    :return-object="false"
                    item-value="value"
                    item-title="text"
                    chips
                    closable-chips
                    hide-details
                    multiple>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('user') }}</span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" style="align-content: center;">
                {{ $store.getters.translate("high_level_overview_with_p_m") }}
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                    class="reg-normal text-primary"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    density="default"
                    v-model="overview_with_p_m_template"
                    :items="templates"
                    :return-object="false"
                    item-value="value"
                    item-title="text"
                    hide-details
                    clearable>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('template') }}</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col>
                <v-autocomplete
                    class="reg-normal text-primary"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    density="default"
                    v-model="overview_with_p_m_users"
                    :items="users"
                    :return-object="false"
                    item-value="value"
                    item-title="text"
                    chips
                    closable-chips
                    hide-details
                    multiple>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('user') }}</span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="reset">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="sendReports">
                  <template #prepend><PhPaperPlaneRight style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("send_report") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../components/commonComponents/BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhPaperPlaneRight, PhX} from "@phosphor-icons/vue";

export default {
  props: ["project_id"],
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhPaperPlaneRight, PhX,
  },
  data() {
    return {
      overview_users: [35, 100],
      overview_with_e_i_users: [89],
      overview_with_p_m_users: [155],
      overview_template: 8,
      overview_with_e_i_template: 9,
      overview_with_p_m_template: 10,
      users: [],
      templates: [],
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.openModal('send_project_reports');
      await this.getUsers();
      await this.getTemplates();
    },
    async getUsers() {
      this.users = await helpFunctions.getAdditionalModelsForDropdowns("user", "id", ["name"]);
    },
    async getTemplates() {
      this.templates = await helpFunctions.getAdditionalModelsForDropdowns("template", "id", ["name"]);
    },
    async sendReports() {
      await helpFunctions.postCustomRoute(this.$toast, "send-project-reports", { project_id: this.project_id, overview_users: this.overview_users,
        overview_with_e_i_users: this.overview_with_e_i_users, overview_with_p_m_users: this.overview_with_p_m_users, overview_template: this.overview_template,
        overview_with_e_i_template: this.overview_with_e_i_template, overview_with_p_m_template: this.overview_with_p_m_template }, true, true);
      this.reset();
    },
    reset() {
      this.overview_users = [35, 100];
      this.overview_with_e_i_users = [89];
      this.overview_with_p_m_users = [155];
      this.overview_template = 8;
      this.overview_with_e_i_template = 9;
      this.overview_with_p_m_template = 10;
      this.closeModal('send_project_reports');
    },
  },
};
</script>